export const MODELS_REQUESTED = 'MODELS_REQUESTED'
export const GET_MODELS_SUCCESS = 'GET_MODELS_SUCCESS'
export const GET_MODELS_FAILED = 'GET_MODELS_FAILED'
export const SAVE_PAGE_STATE = 'SAVE_PAGE_STATE'
export const ARGS_MODEL_EXAMPLE = 'ARGS_MODEL_EXAMPLE'
export const NEGATIVE_ARGS_MODEL_EXAMPLE = 'NEGATIVE_ARGS_MODEL_EXAMPLE'
export const SAVE_PAGE_PROGRESS = 'SAVE_PAGE_PROGRESS'
export const GET_FAVOURITES_MODELS = 'GET_FAVOURITES_MODELS'
export const FAVOURITES_MODELS_REQUESTED = 'FAVOURITES_MODELS_REQUESTED'
export const GET_CURRENT_MODEL = 'GET_CURRENT_MODEL'
export const CURRENT_MODEL_REQUESTED = 'CURRENT_MODEL_REQUESTED'
export const GET_CURRENT_MODEL_FAILED = 'GET_CURRENT_MODEL_FAILED'
export const SET_VIEW_MODE = 'SET_VIEW_MODE'
